import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@norvix/ui/styles/base.css';

import { App } from './App.js';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
